import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject, OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import { MessageService } from 'src/app/_service/message.service';
import { Atendimento } from '../_model/atendimento';
import { Documento } from '../_model/documento';
import { AtendimentoService } from '../_service/atendimento.service';
import {
  ModalContatoComponent,
} from '../_shared/modal-contato/modal-contato.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import {DatalayerService} from "../_service/datalayer.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {

  @ViewChild('modalContato')
  modalContato: ModalContatoComponent;

  rotaAtual: string = '';

  atendimentos: Atendimento[];
  fabActive = false;
  politicaPrivacidade: Documento;
  codigoEtica: Documento;
  segurancaCibernetica: Documento;
  idConcessionaria: string;
  private unsubscribe$: Subject<void> = new Subject<void>();

  links = [
    {
      label: 'Site institucional',
      title: 'Site institucional',
      href: 'https://www.mercedes-benz-trucks.com.br/',
      external: true
    },
    {
      label: 'Showroom',
      title: 'Showroom',
      href: 'https://showroommercedes-benz.com.br',
      external: true
    },
    {
      label: 'Caminhões',
      title: 'Veículos',
      routerLink: 'veiculos'
    },
    {
      label: 'Peças e Serviços',
      title: 'Peças e Serviços',
      routerLink: '/cotacao-pecas'
    }
  ];

  currentYear: number;

  constructor(
      @Inject(PLATFORM_ID) private platformId: object,
      public router: Router,
      private activatedRoute: ActivatedRoute,
      private atendimentoService: AtendimentoService,
      private messageService: MessageService,
      private datalayerService: DatalayerService,
  ) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    const documents = this.activatedRoute.snapshot.data['documentos'];
    this.politicaPrivacidade
        = documents.find(document => document.codigo === 'PoliticaPrivacidade');
    this.codigoEtica
        = documents.find(document => document.codigo === 'CodigoEtica');
    this.segurancaCibernetica
        = documents.find(document => document.codigo === 'PoliticaSegurancaCibernetica');
    this.getAtendimentos();

    this.rotaAtual = this.router.url;

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        const nav = event as NavigationEnd;
        this.rotaAtual = nav.urlAfterRedirects;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private getAtendimentos(): void {
    this.atendimentoService.getAll()
        .pipe(
            takeUntil(this.unsubscribe$),
        )
        .subscribe({
              next: (response) => {
                this.atendimentos = response;
              },
              error: (err) => {
                console.log(err);
              },
            },
        );
  }

  voltarTopo(): void {
    window.scrollTo(0, 0);
  }

  abrirModal(): void {
    this.modalContato.openModal();
  }

  getFabActive(): boolean {
    return this.fabActive;
  }

  setFabActive(status: boolean): void {
    this.fabActive = status;
  }

  toggleFab(): void {
    this.setFabActive(
        !this.getFabActive(),
    );
  }

  sendSchedulingWhatsappDatalayer() {
    let name = this.atendimentos?.filter(e => e.id == this.idConcessionaria)[0].nome;

    if(name) {
      this.datalayerService.sendDatalayer('agendamento_whatsapp', {
        'concessionaria': name,
      })
    }
  }

  startService(): void {
    if (!this.idConcessionaria || this.idConcessionaria === '') {
      this.messageService.warning(
          'Seleciona uma concessionária para entrar em contato.',
          'Atenção',
      );
      return;
    }

  this.sendSchedulingWhatsappDatalayer()

    this.atendimentoService.get(this.idConcessionaria)
        .pipe(
            takeUntil(this.unsubscribe$),
        )
        .subscribe({
              next: (response) => {
                this.getAtendimentoSuccess(this.idConcessionaria, response);
              },
              error: (err) => {
                this.getAtendimentoError(err);
              },
            },
        );
  }

  private getAtendimentoError(err: HttpErrorResponse): void {
    this.messageService.error(
        'Não foi possível iniciar o atendimento.',
        'Erro',
    );
    console.log(err);
  }

  private getAtendimentoSuccess(idConcessionaria: string, response: Atendimento): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const mensagem = this.atendimentos.filter(e => e.id == idConcessionaria)[0].mensagem;
    const link = `https://api.whatsapp.com/send?phone=${ response.numero }&text=${ mensagem }`;
    const bodyElement = document.querySelector('body');

    const fakeWhatsappElement = document.createElement('a');
    fakeWhatsappElement.href = link;
    fakeWhatsappElement.id = 'fakeWhatsElem';
    fakeWhatsappElement.target = '_blank';

    bodyElement.append(fakeWhatsappElement);

    document.getElementById('fakeWhatsElem').click();

    // The new window, or tab, will open, free the new <a> tag from body
    document.getElementById('fakeWhatsElem').remove();
  }
}
